import React from "react";
import BaseInputNumberInteger from "./BaseInputNumberInteger";

interface CompactHoursMinutesInputProps {
  value: number; // Value in minutes
  onChange: (minutes: number) => void;
}

export const CompactHoursMinutesInput: React.FC<
  CompactHoursMinutesInputProps
> = ({ value, onChange }) => {
  const hours = Math.floor(value / 60);
  const minutes = value % 60;

  const handleHoursChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newHours = parseInt(e.target.value) || 0;
    onChange(newHours * 60 + minutes);
  };

  const handleMinutesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMinutes = parseInt(e.target.value) || 0;
    onChange(hours * 60 + newMinutes);
  };

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-1">
        <BaseInputNumberInteger
          value={hours}
          onChange={handleHoursChange}
          min={0}
          className="w-16"
        />
        <span className="text-sm">hrs</span>
      </div>
      <div className="flex items-center gap-1">
        <BaseInputNumberInteger
          value={minutes}
          onChange={handleMinutesChange}
          min={0}
          max={59}
          className="w-16"
        />
        <span className="text-sm">min</span>
      </div>
    </div>
  );
};
